var _defs, _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTurkey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 18.968,
    viewBox: "0 0 28 18.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-3{fill:#b50808}.prefix__cls-4{fill:#f3f4f5}.prefix__cls-5{fill:#bac4cc}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "prefix__turkey",
    transform: "translate(0 -80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_393",
    d: "M28 96.348a2.614 2.614 0 0 1-2.71 2.619H2.71A2.614 2.614 0 0 1 0 96.348V82.619A2.614 2.614 0 0 1 2.71 80h22.58A2.614 2.614 0 0 1 28 82.619z",
    "data-name": "Path 393",
    style: {
      fill: "#db2727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_394",
    d: "M48 80h22.581a2.614 2.614 0 0 1 2.71 2.619v13.729a2.814 2.814 0 0 1-2.935 2.619",
    "data-name": "Path 394",
    transform: "translate(-45.29)",
    style: {
      fill: "#ce2420"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_206",
    "data-name": "Group 206",
    transform: "translate(0 80)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_395",
    d: "M48 80h22.581a2.614 2.614 0 0 1 2.71 2.619v5.058",
    className: "prefix__cls-3",
    "data-name": "Path 395",
    transform: "translate(-45.29 -80)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_396",
    d: "M28 368.045a2.571 2.571 0 0 1-2.71 2.665H2.71A2.689 2.689 0 0 1 0 368",
    className: "prefix__cls-3",
    "data-name": "Path 396",
    transform: "translate(0 -351.742)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_397",
    d: "M54.2 122.181a2.477 2.477 0 0 1 2.484-2.484 2.428 2.428 0 0 1 1.265.361 3.026 3.026 0 1 0 0 4.335 2.428 2.428 0 0 1-1.265.361 2.617 2.617 0 0 1-2.484-2.573z",
    className: "prefix__cls-4",
    "data-name": "Path 397",
    transform: "translate(-49.819 -36.987)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_398",
    d: "M95.2 118.932l.677.587a2.629 2.629 0 0 1 .858-.135 2.428 2.428 0 0 1 1.265.361 3.005 3.005 0 0 0-2.123-.858 1.664 1.664 0 0 0-.677.045z",
    className: "prefix__cls-5",
    "data-name": "Path 398",
    transform: "translate(-89.826 -36.674)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_399",
    d: "M151.665 143.2l.587.994 1.174-.271-.768.9.632 1.039-1.129-.452-.768.9.09-1.219-1.084-.452 1.174-.271z",
    className: "prefix__cls-4",
    "data-name": "Path 399",
    transform: "translate(-141.91 -59.632)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_400",
    d: "M154.516 144.194l-.587-.994-.09 1.174-1.039.271.181.135.768.316v.361l.361.316.316-.361 1.129.452-.632-1.039.768-.9z",
    className: "prefix__cls-5",
    "data-name": "Path 400",
    transform: "translate(-144.174 -59.632)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkey);
export default __webpack_public_path__ + "static/media/turkey.3339b634e5a398e100d17fa7f192211f.svg";
export { ForwardRef as ReactComponent };